import React from 'react';
import { useFormContext } from 'react-hook-form';

import FormCheckbox from '../../../../components/formCheckbox/FormCheckbox';
import FormNewCheckbox from '../../../../components/formCheckbox/FormNewCheckbox';
import SectionContainer from '../../../../components/template/SectionContainer/SectionContainer';
import Subtitle from '../../../../components/template/Subtitle/Subtitle';
import Title from '../../../../components/template/Title/Title';
import { DropdownOptions } from '../../../../models/formModel';
import useFormStore from '../../../../store/FormStore';

interface MainQuestionProps {
  id: string;
  title: string;
  description: string;
  compulsoryQuestions: {
    id: string;
    question: string;
    inputs: DropdownOptions[];
  }[];
  probabilityQuestions: {
    id: string;
    question: string;
    inputs: DropdownOptions[];
  }[];
}

const MainQuestion: React.FC<MainQuestionProps> = ({
  id,
  title,
  description,
  compulsoryQuestions = [],
  probabilityQuestions = [],
}) => {
  const { watch } = useFormContext();
  const question = watch(id);

  return (
    <SectionContainer>
      <Title>{title}</Title>
      <Subtitle>{description}</Subtitle>

      {compulsoryQuestions.map((ques, idx) => (
        <FormCheckbox
          id={ques.id}
          key={idx}
          label={ques.question}
          options={ques.inputs}
          required
        />
      ))}

      {question?.compulsory && question?.compulsory == 'Yes' && (
        <>
          {probabilityQuestions.map((ques) => (
            <>
              {ques.question}

              {ques.inputs.map((inp, idx) => (
                <FormNewCheckbox
                  key={idx}
                  id={ques.id}
                  label={inp.label as any}
                  value={inp.value}
                  required
                />
              ))}
            </>
          ))}
        </>
      )}
    </SectionContainer>
  );
};

export default MainQuestion;
